var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapFast0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11835 12.85C2.11835 12.4634 2.43175 12.15 2.81834 12.15H6.66831C7.05491 12.15 7.36831 12.4634 7.36831 12.85C7.36831 13.2366 7.05491 13.55 6.66831 13.55H2.81834C2.43175 13.55 2.11835 13.2366 2.11835 12.85Z",
    fill: "#0060CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06836 9C1.06836 8.6134 1.38176 8.30001 1.76835 8.30001H4.91833C5.30492 8.30001 5.61832 8.6134 5.61832 9C5.61832 9.3866 5.30492 9.69999 4.91833 9.69999H1.76835C1.38176 9.69999 1.06836 9.3866 1.06836 9Z",
    fill: "#0060CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46835 5.15003C2.46835 4.76344 2.78175 4.45004 3.16834 4.45004H6.66831C7.05491 4.45004 7.36831 4.76344 7.36831 5.15003C7.36831 5.53663 7.05491 5.85003 6.66831 5.85003H3.16834C2.78175 5.85003 2.46835 5.53663 2.46835 5.15003Z",
    fill: "#0060CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5256 2.04906C12.8246 2.16724 13.0046 2.47389 12.9621 2.79257L12.3678 7.25001H15.0301C15.0381 7.25001 15.0461 7.25001 15.0542 7.25001C15.2087 7.24998 15.3689 7.24994 15.5012 7.26204C15.6313 7.27393 15.868 7.30546 16.0797 7.46879C16.3264 7.65927 16.4758 7.94956 16.4874 8.2611C16.4973 8.52824 16.3853 8.73921 16.3194 8.85202C16.2523 8.96669 16.1592 9.09699 16.0694 9.2227C16.0647 9.22927 16.06 9.23582 16.0554 9.24236L11.4379 15.7068C11.251 15.9684 10.91 16.0691 10.611 15.9509C10.312 15.8328 10.1319 15.5261 10.1744 15.2074L10.7687 10.75H8.10649C8.09846 10.75 8.09041 10.75 8.08234 10.75C7.92782 10.75 7.76767 10.7501 7.63538 10.738C7.50525 10.7261 7.26851 10.6945 7.05688 10.5312C6.81009 10.3407 6.6607 10.0504 6.64915 9.7389C6.63924 9.47176 6.75119 9.26079 6.81715 9.14798C6.8842 9.03331 6.97731 8.90301 7.06715 8.7773C7.07184 8.77073 7.07652 8.76418 7.08119 8.75764L11.6987 2.29319C11.8855 2.03157 12.2266 1.93089 12.5256 2.04906Z",
    fill: "#0060CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapFast0);
export default __webpack_public_path__ + "static/media/zap-fast0.020e43dad99db3cebe1a58af475791c6.svg";
export { ForwardRef as ReactComponent };